"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _dealerList = _interopRequireDefault(require("../../styles/dealer-list.css"));
var StatusLabel = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(StatusLabel, _React$Component);
  function StatusLabel(props) {
    return _React$Component.call(this, props) || this;
  }
  var _proto = StatusLabel.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      searchValue = _this$props.searchValue,
      dealerListLength = _this$props.dealerListLength,
      searchResultsFoundLabel = _this$props.searchResultsFoundLabel,
      noDealershipFoundMessage = _this$props.noDealershipFoundMessage,
      theme = _this$props.theme;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _dealerList["default"].statusLabel,
      tabIndex: -1
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: dealerListLength === 0 ? "" + _dealerList["default"].searchErr : "" + theme.bodyCopy
    }, dealerListLength === 0 ? "" + noDealershipFoundMessage : dealerListLength + " " + searchResultsFoundLabel + " " + searchValue));
  };
  return StatusLabel;
}(_react["default"].Component);
var _default = StatusLabel;
exports["default"] = _default;